class BackToTop extends HTMLElement {
    constructor() {
        super();

        this.toggleBackToTop = this.toggleBackToTop.bind(this);
    }

    connectedCallback() {
        this.BackToTop = this;
        this.button = this.querySelector('button');
        this.bindEvents();
    }

    bindEvents() {
        if (this.BackToTop) {
            // init once in case page is already scrolled on load
            this.toggleBackToTop(window.scrollY);
            // then add event listener
            window.addEventListener('scroll', this.toggleBackToTop);
        }

        if (this.button) {
            this.button.addEventListener('click', this.scrollToTop);
        }
    }

    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    toggleBackToTop() {
        const scrollPosition = window.scrollY;
        const toggleAt = 400;

        if (scrollPosition > toggleAt) {
            this.BackToTop.classList.add('back-to-top--visible');
        } else {
            this.BackToTop.classList.remove('back-to-top--visible')
        }
    }
}

customElements.define('w3-back-to-top', BackToTop);
